var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout"},[_c('dx-header',{on:{"toggle-menu":_vm.toggleMenu}}),_vm._v(" "),_c('dx-mobile-nav',{attrs:{"active":_vm.activeMenu}}),_vm._v(" "),_c('dx-notification'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c19e43a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/BaseLayout.vue
// module id = null
// module chunks = 